import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"

function GenderIdentityDecisionStepContent({ isPartnerSection }: { isPartnerSection: boolean }): JSX.Element {
  const benefitConfiguration = useGetBenefit()
  const lgbtqEnabled = benefitConfiguration.data?.generalSupport.showLgbtqContent
  const { send } = useStateMachine(null)

  useEffect(() => {
    if (lgbtqEnabled) {
      send("YES")
      return
    }
    if (isPartnerSection) {
      send("NO")
      return
    }
    send("NO")
  }, [lgbtqEnabled, isPartnerSection, send])
  return <></>
}

export function AboutYouGenderIdentityDecisionStep(): JSX.Element {
  return <GenderIdentityDecisionStepContent isPartnerSection={false} />
}

export function PartnerGenderIdentityDecisionStep(): JSX.Element {
  return <GenderIdentityDecisionStepContent isPartnerSection />
}
